function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "a",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 25,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2 2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M293.815,29.2l-1.858-1.858a4.05,4.05,0,0,0-.837-4.475,4,4,0,0,0-2.85-1.18h0a4.03,4.03,0,1,0,1.571,7.737l1.876,1.876a1.486,1.486,0,0,0,2.1,0,1.494,1.494,0,0,0,.436-1.049A1.474,1.474,0,0,0,293.815,29.2Zm-2.863-1.74a3.115,3.115,0,0,1-.421.52,3.173,3.173,0,0,1-.523.424,3.211,3.211,0,0,1-4-.422,3.2,3.2,0,0,1,2.263-5.462h0a3.177,3.177,0,0,1,2.262.937A3.21,3.21,0,0,1,290.952,27.457Z",
  transform: "translate(-273.279 -10.73)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M272.89,5.479a4.664,4.664,0,0,1,.994.1V1.7a1.17,1.17,0,0,1-.416.075h-3.878A2.12,2.12,0,0,1,267.469-.35V-4.228a1.266,1.266,0,0,1,.071-.416h-8.346a1.294,1.294,0,0,0-1.294,1.29V14.869a1.294,1.294,0,0,0,1.294,1.29h13.4A1.287,1.287,0,0,0,273.86,15.1a5,5,0,0,1-.965.1,4.822,4.822,0,0,1-3.445-1.423,4.872,4.872,0,0,1-1.244-2.126h-6.994a.416.416,0,1,1,0-.832h6.836c-.012-.158-.021-.32-.021-.478a4.826,4.826,0,0,1,.212-1.431h-7.027a.416.416,0,1,1,0-.832h7.372a4.782,4.782,0,0,1,1.806-1.906h-9.174a.416.416,0,0,1,0-.832h9.357a.417.417,0,0,1,.416.416.364.364,0,0,1-.025.116A4.864,4.864,0,0,1,272.89,5.479ZM261.216-.138H266.8a.416.416,0,1,1,0,.832h-5.579a.416.416,0,0,1,0-.832Zm9.357,3.574h-9.357a.416.416,0,0,1,0-.832h9.357a.416.416,0,1,1,0,.832Z",
  transform: "translate(-257.9 4.644)",
  fill: "#bdbdbd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M284.19.94h3.878a.418.418,0,0,0,.383-.254.415.415,0,0,0-.092-.454l-4.751-4.751a.408.408,0,0,0-.454-.092.413.413,0,0,0-.254.383V-.349A1.291,1.291,0,0,0,284.19.94Z",
  transform: "translate(-272.499 4.643)",
  fill: "#bdbdbd"
})));

var SvgPesquisa = function SvgPesquisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPesquisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pesquisa.64b7e66c.svg";
export { ForwardRef as ReactComponent };